
/*
* 逗号替换为/
*/
function replaceSlash (val) {
  var res = val.toString().replaceAll(',', ' / ')
  return res
}

export { replaceSlash }



// WEBPACK FOOTER //
// ./src/utils/filter.js